import { MinLength, MaxLength } from "class-validator";
import {
  validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
  IsDate, Min, Max
} from "class-validator";
import { ValidateIf, IsNotEmpty, IsNumber, IsString, IsEmpty } from "class-validator";


export class Cmsma {
  @MaxLength(10, { message: 'COMPANY 字串太長' })
  @IsString({ message: 'COMPANY 不是字串型態' })
  COMPANY: string = "";

  @MaxLength(10)
  CREATOR: string = "";

  @MaxLength(10)
  USR_GROUP: string = "";

  @MaxLength(8)
  CREATE_DATE: string = "";

  @MaxLength(10)
  MODIFIER: string = "";

  @MaxLength(8)
  MODI_DATE: string = "";

  @IsNumber()
  @Max(999)
  FLAG: number = 0;


  @IsNotEmpty({ message: '日期格式 (MA001) 不可空白' })
  @MaxLength(1, { message: '日期格式 (MA001) 資料太長' })
  MA001: string = '';            // 日期格式 1 4.民國年 YYMMDD、5.民國年 YYYMMDD、1.西元年 YYYYMMDD、2.西元年 MMDDYYYY、3.西元年 DDMMYYYY

  @MaxLength(1, { message: '日期區隔符號 (MA002) 資料太長' })
  MA002: string = '';            // 日期區隔符號 1 1.-、2./

  @MaxLength(4, { message: '本國幣別 (MA003) 資料太長' })
  MA003: string = '';            // 本國幣別 4 本國使用幣別代號

  @IsNumber()
  MA004: number = 0;            // 營業稅率(%) 5.4 營業稅率(%)&&87-09-03del&&89-06-07 OLD:07.6

  @MaxLength(1, { message: 'MRP使用NetChang (MA005) 資料太長' })
  MA005: string = '';            // MRP使用NetChang 1 Y/N&&88-12-09MODI

  @MaxLength(1, { message: '稅額 (MA006) 資料太長' })
  MA006: string = '';            // 稅額 1 (稅額)1.整張資料計算 2.單身單筆資料計算 //移至客戶及廠商個別控管

  @MaxLength(10, { message: '商品分類方式一 (MA007) 資料太長' })
  MA007: string = '';            // 商品分類方式一 10 商品分類方式一

  @MaxLength(10, { message: '商品分類方式二 (MA008) 資料太長' })
  MA008: string = '';            // 商品分類方式二 10 商品分類方式二

  @MaxLength(10, { message: '商品分類方式三 (MA009) 資料太長' })
  MA009: string = '';            // 商品分類方式三 10 商品分類方式三

  @MaxLength(10, { message: '商品分類方式四 (MA010) 資料太長' })
  MA010: string = '';            // 商品分類方式四 10 商品分類方式四

  @MaxLength(6, { message: '庫存現行年月 (MA011) 資料太長' })
  MA011: string = '';            // 庫存現行年月 6 庫存現行年月[FORMATE:YM]

  @MaxLength(6, { message: '庫存關帳年月 (MA012) 資料太長' })
  MA012: string = '';            // 庫存關帳年月 6 庫存關帳年月[FORMATE:YM]

  @MaxLength(8, { message: '帳務凍結日期 (MA013) 資料太長' })
  MA013: string = '';            // 帳務凍結日期 8 帳務凍結日期[FORMATE:YMD]

  @MaxLength(1, { message: '成本計價方式 (MA014) 資料太長' })
  MA014: string = '';            // 成本計價方式 1 1.標準成本制、2.月加權平均成本制   &&890209 MARK 3.移動平均成本制

  @MaxLength(2, { message: '會計現行期別 (MA015) 資料太長' })
  MA015: string = '';            // 會計現行期別 2 會計現行期別

  @MaxLength(1, { message: '會計期制 (MA016) 資料太長' })
  MA016: string = '';            // 會計期制 1 1.12期 2.13期  && modi年度認定方式

  @MaxLength(6, { message: '更新低階碼 (MA017) 資料太長' })
  MA017: string = '';            // 更新低階碼 6 更新低階碼&&88-02-26

  @MaxLength(2, { message: '會計關帳期別 (MA018) 資料太長' })
  MA018: string = '';            // 會計關帳期別 2 會計關帳期別&&88-03-01.4碼=>2碼

  @MaxLength(4, { message: '會計現行年度 (MA019) 資料太長' })
  MA019: string = '';            // 會計現行年度 4 會計現行年度[FORMATE:Y]&&88-02-10.6碼=>4碼

  @MaxLength(4, { message: '會計關帳年度 (MA020) 資料太長' })
  MA020: string = '';            // 會計關帳年度 4 會計關帳年度[FORMATE:Y]&&88-03-01.6碼=>4碼

  @MaxLength(6, { message: '銀行存款現行年月 (MA021) 資料太長' })
  MA021: string = '';            // 銀行存款現行年月 6 銀行存款現行年月[FORMATE:YM]

  @MaxLength(6, { message: '計薪年月 (MA022) 資料太長' })
  MA022: string = '';            // 計薪年月 6 計薪年月[FORMATE:YM]&&880906 10碼=>6碼

  @MaxLength(1, { message: '一品號對應多條碼 (MA023) 資料太長' })
  MA023: string = '';            // 一品號對應多條碼 1 一品號對應多條碼&&88-12-13 MODI OLD:預留 C10

  @MaxLength(1, { message: '數量表達方式 (MA024) 資料太長' })
  MA024: string = '';            // 數量表達方式 1 1.單一單位2.雙單位3.製造雙單位&&87-09-03add

  @MaxLength(1, { message: '確認日依據 (MA025) 資料太長' })
  MA025: string = '1';            // 確認日依據 1 1.系統日、2.單據日[DEF:'1']&&89-05-25add

  @MaxLength(1, { message: '產品功能別 (MA026) 資料太長' })
  MA026: string = '1';            // 產品功能別 1 1.台灣版、2.大陸版[DEF:'1']&&89-06-21 ADD

  @MaxLength(6, { message: '應收現行年月 (MA027) 資料太長' })
  MA027: string = '';            // 應收現行年月 6 應收現行年月[FORMATE:YM]  //900103ADDV2.1

  @MaxLength(6, { message: '應收關帳年月 (MA028) 資料太長' })
  MA028: string = '';            // 應收關帳年月 6 應收關帳年月[FORMATE:YM]  //900103ADDV2.1

  @MaxLength(6, { message: '應付現行年月 (MA029) 資料太長' })
  MA029: string = '';            // 應付現行年月 6 應付現行年月[FORMATE:YM]  //900507ADDV2.1

  @MaxLength(6, { message: '應付關帳年月 (MA030) 資料太長' })
  MA030: string = '';            // 應付關帳年月 6 應付關帳年月[FORMATE:YM]  //900507ADDV2.1

  @MaxLength(1, { message: '數值欄位三位一撇 (MA031) 資料太長' })
  MA031: string = 'N';            // 數值欄位三位一撇 1 Y/N [DEF:"N"]             //900828 add 3.1

  @MaxLength(1, { message: '執行電子表單流程 (MA032) 資料太長' })
  MA032: string = 'N';            // 執行電子表單流程 1 Y/N [DEF:"N"]             //910221 add 3.1


}
